import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// 用户端页面
import IntroPage from './pages/IntroPage';
import MyReportsPage from './pages/MyReportsPage';
import ConsentPage from './pages/ConsentPage';
import DemographicPage from './pages/DemographicPage';
import QuestionnairePage from './pages/QuestionnairePage';
import AnalysisPage from './pages/AnalysisPage';
import ReportPage from './pages/ReportPage';

// 管理端页面
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AuthCodeManagement from './pages/admin/AuthCodeManagement';
import TestResults from './pages/admin/TestResults';

// 组件
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        {/* 用户端路由 */}
        <Route path="/" element={<IntroPage />} />
        <Route path="/my-reports" element={<MyReportsPage />} />
        <Route path="/consent/:type" element={<ConsentPage />} />
        <Route path="/demographic/:type" element={<DemographicPage />} />
        <Route path="/questionnaire/:type" element={<QuestionnairePage />} />
        <Route path="/analysis/:type" element={<AnalysisPage />} />
        <Route path="/report/:type" element={<ReportPage />} />

        {/* 管理端路由 */}
        <Route path="/XiaoXin/login" element={<AdminLogin />} />
        <Route path="/XiaoXin" element={<ProtectedRoute />}>
          <Route index element={<Navigate to="/XiaoXin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="authcodes" element={<AuthCodeManagement />} />
          <Route path="results" element={<TestResults />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
